import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, UsersResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }
        this.st = new SmartTable();
    }
    search() {
        this.spAlert = null;
        this.selectedCompanyUser = null;
        this.isSearching = true;

        this.UsersResource
            .getCompanyUserForSaaspassUser(this.companyId,this.searchText)
            .then((companyUser) => {
                    this.selectedCompanyUser = companyUser;
                }
            )
            .catch((response) => {
                if (response.status === 404) {
                    this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            })
            .finally(() => this.isSearching = false);
    }

    copy() {
        const accountIds = this.accounts
            .filter(({isCopyable}) => isCopyable)
            .map(({id}) => id);
        this.isSaving = true;
        this.AccountsResource.bulkCopyCompanySharedAccount(this.companyId,this.companyUser.id,this.selectedCompanyUser,accountIds)
            .then(() => {
                const accounts = null;
                this.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
                this.$state.go('^');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.controller.js